import * as types from "../actionTypes";
import initialState from "reducers/initialState";
import * as eventTypes from "../eventTypes";

export default function incomeTypesReducer(state = initialState.currentOffer.clientIncomeTypesData, action) {
  switch (action.type) {
    case types.LOAD_OFFER_PARTNER_INCOME_TYPES_SUCCEEDED: {
      const { partnerIncomeTypes } = action.payload;
      const partnerId = partnerIncomeTypes.partnerId;
      const incomeTypes = {
        ...state.incomeTypes,
        [partnerId]: {
          partnerId,
          isLoaded: true,
          loading: {}
        }
      };

      return {
        ...state,
        incomeTypes
      };
    }

    case eventTypes.OFFER_PARTNER_ALL_INCOME_TYPES_INVALIDATED: {
      const { partnerId } = action.event.eventBody;
      return {
        ...state,
        incomeTypes: {
          ...state.incomeTypes,
          [partnerId]: {
            partnerId,
            isLoaded: false,
            loading: {}
          }
        }
      };
    }

    case types.OFFER_PARTNER_INCOME_TYPE_UPDATE_STARTED: {
      const { partnerId, incomeTypeId } = action.payload.data;
      const existing = state.incomeTypes[partnerId];

      return {
        ...state,
        incomeTypes: {
          ...state.incomeTypes,
          [partnerId]: {
            ...existing,
            loading: {
              ...existing.loading,
              [incomeTypeId]: true
            }
          }
        }
      };
    }

    case types.OFFER_PARTNER_INCOME_TYPE_UPDATE_FAILED:
    case types.OFFER_PARTNER_INCOME_TYPE_UPDATE_SUCCEEDED: {
      const { partnerId, incomeTypeId } = action.payload.data;
      const existing = state.incomeTypes[partnerId];

      return {
        ...state,
        incomeTypes: {
          ...state.incomeTypes,
          [partnerId]: {
            ...existing,
            loading: {
              ...existing.loading,
              [incomeTypeId]: false
            }
          }
        }
      };
    }

    default:
      return state;
  }
}
